export const uk = {
    bannersEdit: 'Редактирование объявлений',
    campaignsEdit: 'Редактирование кампаний',
    clientHistory: 'История изменений',
    clientsReports: 'Отчёт по клиентам',
    deals: 'Список сделок',
    domainsReports: 'Отчёт по доменам',
    freelancerCard: 'Специалист по Яндекс.Директу',
    freelancerCardEdit: 'Анкета специалиста',
    freelancerCustomers: 'Список заказчиков',
    freelancersList: 'Специалисты по настройке Яндекс.Директа',
    groupsEdit: 'Редактирование групп',
    'import-export-wizard': 'Мастер Импорта-Экспорта данных',
    marketerCard: 'Карточка маркетолога',
    marketers: 'Управление маркетологами',
    minusPhrasesLibrary: 'Библиотека минус-фраз',
    mobileAppsCreate: 'Добавить мобильное приложение',
    mobileAppsEdit: 'Просмотр приложения',
    mobileAppsList: 'Мобильные приложения',
    myVideos: 'Мои видео',
    offlineReports: 'Офлайн отчеты',
    pricePackages: 'Список пакетов',
    pricePackagesEdit: 'Редактирование пакетов',
    products: 'Управление продуктами',
    recommendationsItems: 'Рекомендации',
    recommendationsPage: 'Рекомендации',
    tools: 'Инструменты',
    'user-settings': 'Настройки пользователя',
    videoCreate: 'Создание видео',
    videoTemplates: 'Шаблоны',
    welcome: 'Добро пожаловать в Яндекс Директ!'
};
